const joi = require('joi');

const schema = joi.object({
  code: joi.string()
    .required(),
}).options({ abortEarly: false, stripUnknown: true });

export default schema;
